import { action } from 'mobx';
import getRootStore from './getRootStore';
var createStoreAction = action('createStore', function createStoreAction(key, initialState) {
    if (getRootStore().get(key)) {
        throw new Error("A store named " + key + " has already been created.");
    }
    getRootStore().set(key, initialState);
});
export default function createStore(key, initialState) {
    createStoreAction(key, initialState);
    return function () { return getRootStore().get(key); };
}
